import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';
import feedActions from '~/store/core/actions/feed';

export default {
    namespaced: true,
    state: {
        bots: [],
        repositoryName: 'bots',
        filters: {
            name: '',
            status: '',
            date: [],
        },
        conditionsFormSettings: {},
        stats: {
            active_bot_count: 0,
            avg_odds: 0,
            balance: 0,
            inactive_bot_count: 0,
            settled_bet_count: 0,
            settled_stake_sum: 0,
            total_bot_count: 0,
            unsettled_bet_count: 0,
            unsettled_stake_sum: 0,
            win_rate: 0,
            yield: 0,
            yield_flat: 0,
        },
        conditions: {
            isLive: false,
            isLeague: false,
            isLiveStats: false,
            isMarketMargin: false,
            isDball: false,
        },
    },
    mutations: {
        ...mixinMutations(),
        setConditionsFormSettings(state, conditionsFormSettings) {
            state.conditionsFormSettings = conditionsFormSettings;
        },
        setStats(state, stats) {
            state.stats = Object.assign(state.stats, stats);
        },
        setConditions(state, conditions) {
            state.conditions = conditions;
        },
    },
    getters: {
        ...mixinGetters(),
        getConditionsFormSettings(state) {
            return state.conditionsFormSettings;
        },
        getStats(state) {
            return state.stats;
        },
        getConditions(state) {
            return state.conditions;
        },
    },
    actions: {
        ...mixinActions('bot'),
        ...feedActions(),
        afterCreated(context, data) {
            let bots = context.getters.getList;
            bots.push(data.row);
            context.commit('setList', bots);
            // context.commit('setStats', data.stats);
            context.commit('PageModule/setTotal', bots.length, { root: true });
        },
    },
};
